"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetalsOrderItem = void 0;
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
class MetalsOrderItem extends model_core_1.OrderItem {
    index = null;
    properties = {};
    inventory_id = '';
    variant_number = '';
    variant_id = '';
    name = '';
    notes = '';
    url = '';
    unit_cost = null;
    unit_weight = null;
    base_cost = null;
    size = null;
    price = null;
    price_override = null;
    subtotal = null;
    dimensions = new model_core_1.DimensionArray();
    fixed_dimensions = '';
    quantity = 0;
    metadata = {};
    added = null;
    pricing_id = '';
    pricing = null;
    constructor(data, olMap) {
        super(data, olMap, 'items', 19);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, MetalsOrderItem);
        // TODO Deprecate at some point.
        // SKU replaces variant_number
        if (this.variant_number) {
            this.sku = this.variant_number;
        }
        if (this.base_cost) {
            this.unit_cost = this.base_cost;
        }
        if (data?.cost) {
            this.unit_cost = data.cost;
            this.base_cost = data.cost;
        }
        if (data?.weight) {
            this.unit_weight = data.weight;
        }
        if (data?.sku) {
            this.variant_number = data.sku;
        }
    }
    toString() {
        return `OrderItem: ${this.variant_number}: ${this.dimensions.toString()}`;
    }
    incr(increment, u) {
        if (increment > 0) {
            if (!this.quantity) {
                this.quantity = increment;
            }
            else {
                this.quantity += increment;
            }
        }
        else {
            if ((this.quantity + increment) >= 0) {
                this.quantity += +increment;
            }
            else {
                this.quantity = 0;
            }
        }
        this.calc(u);
    }
    calc(u) {
        // console.log('--------');
        // SIZE IN FEET (OR SQ. FEET)
        let feet = (this.dimensions)?.getFeet ? (this.dimensions)?.getFeet() : 0;
        //PRICE
        if (feet && this.pricing?.components?.length) {
            // feet = round(feet, 2);
            // Sort price components by minimum length so we always know the lowest items are first
            this.pricing?.components.sort((a, b) => {
                return (a.feet < b.feet) ? -1 : 1;
            });
            let piece_weight = Number(this.unit_weight || 0) * feet;
            let cost = Number(this.base_cost || this.unit_cost || 1) * piece_weight;
            let m = this.pricing.components.reduce((m, comp) => {
                if (!m && feet <= Number(comp.feet) && comp.margin) {
                    m = Number(comp.margin);
                }
                return m;
            }, 0);
            let margin = (((m || this.pricing.metadata.minimum) / 100) + 1);
            this.price = (0, model_core_1.round)((cost * margin), 2);
            this.subtotal = (0, model_core_1.round)(this.quantity * ((isNaN(this.price) === false) ? Number(this.price) : 0), 2);
            this._override_weight = Number(piece_weight) * this.quantity;
            this._override_weight = (0, model_core_1.round)(this._override_weight, this._override_weight < 1 ? 4 : 2);
            if (u) {
                this._margin = { feet: (0, model_core_1.round)(feet, 2), m: margin, p: m, cost: (0, model_core_1.round)(cost * this.quantity, 2), weight: this.total_weight };
            }
        }
    }
    isLTL() {
        return (this.total_weight > 150 || this.dimensions.largestDimension().size > 108);
    }
    isLittle() {
        let little = false;
        this.dimensions.forEach((dim) => {
            if (dim.variable && dim.size && dim.size < 12) {
                little = true;
            }
        });
        return little;
    }
    toMinJSON(ignoreDocRef) {
        return { variant_number: this.variant_number, name: this.name, id: this.id, _type: this._type };
    }
}
exports.MetalsOrderItem = MetalsOrderItem;
index_1.olm.items = (ref, map) => {
    return new MetalsOrderItem(ref, map);
};
